<template>
		<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>운송보험</li>
					<li>운송보험의 개요</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>운송보험의 개요</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<div class="conStyle1">
						<p class="tit mgt0">운송보험이란?</p>
						<p class="txt">운송보험은 기차, 트럭 등의 육상 운송 수단을 이용하여 화물을 출발지에서 목적지까지 운송 중, 우연한 사고로 인하여 화물에 입은 손해를 보상하는 보험입니다.</p>

						<p class="tit">주요 가입대상</p>
						<ul class="line">
							<li>일반 잡화, 시멘트, 화공품, 식품, 의약품</li>
							<li>일반 기계 (변압기, 인쇄기, 현미경, 사진기, 컴퓨터 부품 등)</li>
							<li>가정용 전기, 전자제품 및 그 부품</li>
							<li>건설공사 및 항만 하역용 중장비</li>
							<li>섬유제품</li>
							<li>유리 및 요업제품, 이사화물, 기타 파손이 쉬운 물건</li>
							<li>수산물류, 야채, 과실, 건조되지 않은 해초 등</li>
						</ul>

						<p class="tit">보험 기간</p>
						<p class="txt">운송인이 운송을 목적으로 보험의 목적물(화물)을 보험증권에 기재한 발송지의 보관장소에서 반출할 때부터 보험증권에 기재된 도착지의 보관장소에 보험 목적물(화물)을 반입(하역위험 포함)할 때까지 입니다.</p>

						<p class="tit">보험의 필요성</p>
						<ol class="line">
							<li>도로 운송 시 차량 사고 및 상/하차 위험에 대한 담보 필요</li>
							<li>도로운송업자 배상책임보험의 보완 기능</li>
							<li>구내 운송의 담보</li>
						</ol>

						<p class="tit">보험 계약의 유형</p>
						<ol class="num">
							<li>
								계약자/피보험자(화주)
								<ul class="line">
									<li>자기화물운송 특별약관 가입 및 공제금액 (1~5%) 필수 적용</li>
								</ul>
							</li>
							<li>
								계약자(운송인)/피보험자(운송인)
								<ul class="line">
									<li>피보험이익의 부존재로 계약체결 불가능</li>
								</ul>
							</li>
							<li>
								계약자(운송인)/피보험자(화주)
								<ul class="line">
									<li>화주가 운송인에게 보험 가입에 대한 권한을 위임하는 경우의 보험가입 형태로 통상 운송인에 대한 대위권포기특약을 첨부하여 인수함</li>
								</ul>
							</li>
						</ol>

						<p class="tit">운송용구별 할인 및 할증</p>
						<ol class="num">
							<li>
								복합운송(철도+자동차)시 철도운송책임 연장담보 추가
								<ul class="line">
									<li>철도운송 전후 창고에서 창고까지의 책임 연장시 철도편 요율의 20%를 할증 적용하며, 자동차편 요율을 가산 적용하지 않음</li>
								</ul>
							</li>
							<li>
								무개화차(통풍차, 가축차, 우누차 포함) 운송 시 무개차화물담보를 추가
								<ul class="line">
									<li>보험의 목적(화물 종류) 및 담보조건에 따라 할증 요율 적용</li>
								</ul>
							</li>
							<li>
								컨테이너 및 탑차(TOP CAR)에 의해 운송 시 최종 보험료의 20% 할인 적용
								<ul class="line">
									<li>컨테이너란 사방이 철재로 밀폐되어 화물을 차량, 항공기, 선박 등에 적재하여 안전한 운송에 적합하도록 만든 분리가능한 적재용구로 밀폐형 컨테이너만을 의미함</li>
									<li>탑차란 컨테이너와 유사한 용기가 고정 탑재되어 있는 차량</li>
								</ul>
							</li>
							<li>
								보험의 목적인 차량을 TRANSPORTER로 운송할 경우 최종 보험료의 10% 할인 적용
								<ul class="line">
									<li>TRANSPORTER란 차량을 전문적으로 운송하기 위하여 자동차 트레일러에 철재 보조장치를 부착하여, 여러 대의 자동차를 운송할 수 있도록 만든 자동차 운송 전용자동차를 의미함</li>
								</ul>
							</li>
							<li>자동차, 철도, 항공기, 선박 등으로 운송하지 않고 지게차, 리어카, 엘리베이터, 곤도라 등의 운반 및 계단을 통한 도보 운반만의 경우에는 횟수에 상관없이 철도편 요율의 70% 적용</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import util from '@/common/util'
import { sessionUserInfo, load } from '@/common/sessionFactory'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'

</script>

<style>

</style>
